import { reactive } from 'vue'

export const driveTexts = reactive({ $T: {} })

export function updateDriveTexts(texts) {
  Object.entries(texts).forEach(([key, value]) => {
    driveTexts.$T[key] = value
  })
}

export function $T(section, key) {
  if (typeof section === 'string' && typeof key === 'string') {
    return driveTexts.$T[section]?.[key]
  }

  throw new Error('section and keys must both be string')
}

export function formatString(str, ...args) {
  return str.replace(/\{(\d+)\}/g, (match, index) => args[index])
}

export function getTextWidth(text, font) {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = font
  return context.measureText(text).width
}

export function getErrMsg(err) {
  // error code to message
  const errStr = {
    501: $T("error", "file_request_drive_disabled"),
    1015: $T("error", "space_not_enough"),
    1016: $T("error", "file_request_quota_full"),
    1017: $T("error", "file_request_quota_full"),
    1032: $T('error', 'file_request_reserved_name'),
    1035: $T('error', 'name_too_long'),
    1072: $T('error', 'file_request_exceeded_max_upload_size')
  }

  if (err.name === 'NotFoundError') {
    return $T('file_request', 'not_found_error')
  }

  if (err.code) {
    return errStr[err.code] || `Error code: ${err.code}`
  }

  return err || 'Failed'
}
